<div class="databases-management">
  <div class="header">
    <h2>Databases</h2>
    <button class="btn btn-secondary" (click)="loadDatabases()" [disabled]="loading">Refresh</button>
  </div>

  <div *ngIf="error" class="error-message">{{ error }}</div>
  <div *ngIf="loading" class="loading">Loading databases...</div>

  <table *ngIf="!loading && databases.length > 0" class="db-table">
    <thead>
      <tr>
        <th>Database</th>
        <th>Tracking Status</th>
        <th>Tables</th>
        <th>Trigger</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let db of databases">
        <td class="db-name">{{ db.name }}</td>

        <td>
          <span *ngIf="db.statusLoading" class="status-loading">Checking...</span>
          <span *ngIf="!db.statusLoading" class="status-badge" [class.tracked]="db.isTracked" [class.untracked]="!db.isTracked">
            {{ db.isTracked ? 'Tracked' : 'Not tracked' }}
          </span>
        </td>

        <td>
          <span *ngIf="!db.statusLoading" class="check-list">
            <span [class.ok]="db.hasLogs"     [class.missing]="!db.hasLogs">DatabaseLogs</span>
            <span [class.ok]="db.hasVersions" [class.missing]="!db.hasVersions">Versions</span>
          </span>
        </td>

        <td>
          <span *ngIf="!db.statusLoading" class="check-item" [class.ok]="db.hasTrigger" [class.missing]="!db.hasTrigger">
            {{ db.hasTrigger ? 'Active' : 'Missing' }}
          </span>
        </td>

        <td class="actions">
          <button
            *ngIf="!db.isTracked && !db.statusLoading"
            class="btn btn-primary"
            [disabled]="db.initializing"
            (click)="initialize(db)">
            {{ db.initializing ? 'Initializing...' : 'Track Database' }}
          </button>
          <button
            *ngIf="db.isTracked && !db.hasTrigger && !db.statusLoading"
            class="btn btn-warning"
            [disabled]="db.initializing"
            (click)="initialize(db)">
            {{ db.initializing ? 'Repairing...' : 'Repair Trigger' }}
          </button>
          <button
            *ngIf="!db.hasVersions && !db.statusLoading"
            class="btn btn-secondary"
            [disabled]="db.settingUpVersions"
            (click)="setupVersions(db)">
            {{ db.settingUpVersions ? 'Setting up...' : 'Setup Versions' }}
          </button>
          <span *ngIf="db.isTracked && db.hasTrigger" class="all-ok">All set</span>
        </td>
      </tr>
    </tbody>
  </table>

  <!-- Per-row feedback -->
  <div *ngFor="let db of databases">
    <div *ngIf="db.success" class="inline-success">{{ db.name }}: {{ db.success }}</div>
    <div *ngIf="db.error"   class="inline-error">{{ db.name }}: {{ db.error }}</div>
  </div>

  <!-- SQL Scripts Reference -->
  <div class="sql-accordion">
    <h3 class="sql-accordion-title">SQL Scripts Reference</h3>

    <!-- Track Database -->
    <div class="accordion-item">
      <button class="accordion-header" (click)="showTrackDbSql = !showTrackDbSql">
        <span>Track Database</span>
        <span class="accordion-icon">{{ showTrackDbSql ? '▲' : '▼' }}</span>
      </button>
      <div class="accordion-body" *ngIf="showTrackDbSql">
        <pre><code>{{ trackDbSql }}</code></pre>
      </div>
    </div>

    <!-- Setup Versions -->
    <div class="accordion-item">
      <button class="accordion-header" (click)="showSetupVersionsSql = !showSetupVersionsSql">
        <span>Setup Versions</span>
        <span class="accordion-icon">{{ showSetupVersionsSql ? '▲' : '▼' }}</span>
      </button>
      <div class="accordion-body" *ngIf="showSetupVersionsSql">
        <pre><code>{{ setupVersionsSql }}</code></pre>
      </div>
    </div>
  </div>
</div>
